import React from 'react';
import { Modal } from 'react-bootstrap';
import QuizForm from './QuizForm';

/**
 * Edit Quiz. Details and mappings go out with PUT /quiz-admin/:quizId, while
 * each question is saved, deleted and reordered against its own endpoint as
 * soon as the admin acts on it.
 */
const EditQuizManagement = ({ show, onHide, quizId }) => (
    <Modal
        show={show}
        onHide={() => onHide(false)}
        size="xl"
        centered
        className="edit-quiz-modal"
    >
        <Modal.Header closeButton style={{ borderBottom: '1px solid #E2E8F0' }}>
            <Modal.Title>Edit Quiz</Modal.Title>
        </Modal.Header>

        {show && quizId && (
            <QuizForm
                mode="edit"
                quizId={quizId}
                show={show}
                onClose={onHide}
            />
        )}
    </Modal>
);

export default EditQuizManagement;
